import { Injectable } from "@angular/core";
import { GlobalService } from "./global-helper";

export const Role = {
  "Sennebogen": ["SENNEBOGEN"],
  "Basic": ["RD Admin", "RD ST Expert Development User", "RD General Development User", "RD ServiceCenter User", "RD Production User", "RD Dealer User", "RD Owner User", "RD Driver User", "RD Role Management", "RD Academy User"], // vorerst Basic User und Versuch User gleiche Rechte
  "Admin": ["RD Admin"], // engster Entwicklungskreis (Luxi, Engelmann, Gehr)
  "Developer": ["RD Admin", "RD ST Expert Development User", "RD General Development User"],
  "Expert": ["RD ST Expert Development User", "RD Admin"], // RD ADMIN für Entwicklung - prüfen mit zusammenführen von Link jumppoint
  "Delete_DTC": ["RD Admin", "RD ST Expert Development User", "RD General Development User", "RD ServiceCenter User"],
  "Read_Data": ["RD Admin", "RD ST Expert Development User", "RD General Development User", "RD ServiceCenter User", "RD Production User"], //as of now all intern groups
  "MO_Read": ["RD Admin", "RD ST Expert Development User", "RD General Development User", "RD ServiceCenter User"],
  "MO_Write": ["RD Admin", "RD ST Expert Development User", "RD General Development User"],
  "EOL": ["RD ST Expert Development User", "RD General Development User", "RD Production User"]
}

// neue Rollen: "RD Admin", "RD ST Expert Development User", "RD General Development User", "RD ServiceCenter User", "RD Production User", "RD Dealer User", "RD Owner User", "RD Driver User", "RD Role Management"
// alte Rollen: "Steuerungstechnik Admin", "Steuerungstechnik Administrator", "Steuerungstechnik User", "Versuch User"

@Injectable({
    providedIn: 'root'
  })
  export class RoleService {

    userRoles: string[] = []

    constructor(private global: GlobalService) {
        this.global.user.subscribe({
            next: newValue => {this.userRoles = newValue.roles;}});
    }

    public isRole(role: string) {
        if(Object.hasOwn(Role, role)){
          return Object(Role)[role].some((r: string) => this.userRoles.includes(r));
        } else {
          return false;
        }
      }

    
  }